import React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { Checkbox } from '~ui-kit/components/checkbox/checkbox';
import { styled } from '~ui-kit/styled-components';
import { theme } from '~ui-kit/theme';
import { Box } from '../box.component';
import { FormControlLabelWithImg } from '../form-control-label-with-img';
import { Img } from '../img.component';
import { BaseCheckboxProps } from './base-checkbox-props';

interface ImageCheckboxProps extends BaseCheckboxProps, FieldRenderProps<string | number | boolean> {
  srcImg?: string;
}

export function ImageCheckbox({
  label,
  srcImg,
  input: { checked, value, onChange },
  disabled,
  meta,
  ...rest
}: ImageCheckboxProps) {
  return (
    <Box flex-wrap="wrap" flexDirection="column">
      <FormControlLabelWithImg
        control={
          <Box flex-wrap="wrap" flexDirection="column" justifyContent="center" alignItems="center">
            <Icon key="icon" $checked={checked} src={srcImg} />
            <Box
              alignItems="center"
              mx={2}
              my={3}
              style={{
                color: checked ? '#ffffff' : theme.colors.secondaryDark,
                fontSize: '18px',
                height: '48px',
                textAlign: 'center',
              }}
            >
              {label}
            </Box>
            <Checkbox
              key="Checkbox"
              {...rest}
              onChange={onChange}
              checked={!!checked}
              disabled={disabled}
              checkedColor="white"
              value={value}
            />
          </Box>
        }
        label=""
        width={['148px']}
        height={['220px']}
        checked={checked}
      />
    </Box>
  );
}

// When checkbox or radio button is selected apply a filter on the image
const Icon = styled(Img)<{ $checked?: boolean }>`
  vertical-align: middle;
  max-width: 54px;
  max-height: 54px;
  margin-bottom: 8px;
  filter: ${(props) => (props.$checked ? 'brightness(0) invert(1)' : 'invert(0)')};
`;
